import ResourceService from './resource.service'

class PaymentMethodService extends ResourceService {
  static get resource() {
    return 'payment-method'
  }
}

export default PaymentMethodService
